// extracted by mini-css-extract-plugin
export default {"admin_page":"AdminPage_admin_page__siRRP","logo":"AdminPage_logo__nIcLU","box":"AdminPage_box__o65wG","error":"AdminPage_error__-2oel","success":"AdminPage_success__d2h4D"};